import type { ConversationStarter } from './conversation-starters';

export type BannerSlot =
  | { slot: 'recruitment_dashboard' }
  | { slot: 'recruitment_mailbox' }
  | { slot: 'recruitment_candidate_profile'; params: { candidateId: number } }
  | { slot: 'recruitment_candidate_messages'; params: { candidateId: number } };

export type BannerSlotName = BannerSlot['slot'];

export type BannerSuggestion = ConversationStarter;

export interface BannerSuggestions {
  slot: BannerSlotName;
  suggestions: readonly BannerSuggestion[];
}

export const bannerSlotKey = (slot: BannerSlot): string =>
  'params' in slot ? `${slot.slot}:${slot.params.candidateId}` : slot.slot;
